import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as r, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSomewhatSatisfiedFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function f(e, t, l, u, h, a) {
  return d(), r("svg", {
    "aria-label": l.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--somewhat-satisfied-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Somewhat Satisfied Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.375 5.938a5.437 5.437 0 1 0-10.875 0 5.437 5.437 0 0 0 10.875 0Zm-3.5-1.5A.438.438 0 0 0 7.437 4h-.005a.437.437 0 1 0 0 .875h.005a.437.437 0 0 0 .438-.438Zm-3 0A.438.438 0 0 0 4.437 4h-.005a.437.437 0 1 0 0 .875h.005a.437.437 0 0 0 .438-.438Zm3.559 2.734a.438.438 0 0 0-.613-.082l-.083.063a1.688 1.688 0 0 1-1.025.347H5.206c-.394 0-.776-.138-1.08-.39l-.01-.009a.438.438 0 1 0-.56.673l.011.009c.46.382 1.04.592 1.639.592h1.507c.563 0 1.11-.185 1.557-.527l.082-.063a.437.437 0 0 0 .082-.613Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const w = /* @__PURE__ */ o(c, [["render", f]]);
export {
  w as default
};
//# sourceMappingURL=somewhat-satisfied-filled.js.map
